import { render } from "./ViewDetails.vue?vue&type=template&id=f3b29f0c"
import script from "./ViewDetails.vue?vue&type=script&lang=js"
export * from "./ViewDetails.vue?vue&type=script&lang=js"
script.render = render

export default script